import { render } from "./HealthPage.vue?vue&type=template&id=056b3e1f&scoped=true"
import script from "./HealthPage.vue?vue&type=script&lang=js"
export * from "./HealthPage.vue?vue&type=script&lang=js"

import "./HealthPage.vue?vue&type=style&index=0&id=056b3e1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056b3e1f"]])

export default __exports__